/**
 * Build a Bundle — Skout Organic
 * Skio Dynamic Box integration
 *
 * SETUP: Replace SKIO_STOREFRONT_TOKEN with your token from Skio dashboard > Settings > Storefront API
 */

'use strict';

// ─── CONFIG ────────────────────────────────────────────────────────────────
const BAB_CONFIG = {
  SKIO_STOREFRONT_TOKEN: '3ea9cee8-2591-45a8-a9e9-613ac194fdcb', // ← replace this
  BUNDLE_PRODUCT_ID:     '15022956478828',
  MIN_ORDER_CENTS:       3000, // $30.00
  DISCOUNT_TIERS: [
    { thresholdCents: 5000,  pct: 20 }, // $50+ = 20% off
    { thresholdCents: 7500,  pct: 25 }, // $75+ = 25% off
    { thresholdCents: 10000, pct: 30 }, // $100+ = 30% off
  ],
  FREQUENCY_OPTIONS: [
    { label: 'Every 2 weeks', value: null }, // selling plan IDs injected by Liquid below
    { label: 'Every 4 weeks', value: null },
    { label: 'Every 6 weeks', value: null },
    { label: 'Every 8 weeks', value: null },
  ],
};

// ─── STATE ─────────────────────────────────────────────────────────────────
let bundleItems = []; // [{ variantId, title, price, img, sellingPlans: [], qty }]

// ─── HELPERS ───────────────────────────────────────────────────────────────
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

function getTotalCents() {
  return bundleItems.reduce((sum, item) => sum + item.price * item.qty, 0);
}

function getActiveTier(cents) {
  return [...BAB_CONFIG.DISCOUNT_TIERS]
    .reverse()
    .find(t => cents >= t.thresholdCents) || null;
}

function getNextTier(cents) {
  return BAB_CONFIG.DISCOUNT_TIERS.find(t => cents < t.thresholdCents) || null;
}

function formatMoney(cents) {
  return Shopify.formatMoney(cents, '${{amount}}');
}

function showToast(msg) {
  const toast = $('.bab-toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 3000);
}

// ─── TAB SWITCHING ──────────────────────────────────────────────────────────
function initTabs() {
  $$('.bab-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      $$('.bab-tab-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const target = btn.dataset.tab;
      $$('.bab-category').forEach(cat => {
        cat.classList.toggle('visible', cat.dataset.category === target);
      });
    });
  });

  // Activate first tab
  const first = $('.bab-tab-btn');
  if (first) first.click();
}

// ─── BUNDLE MANIPULATION ────────────────────────────────────────────────────
function addToBundle(variantId, title, price, img, sellingPlans) {
  const existing = bundleItems.find(i => i.variantId === variantId);
  if (existing) {
    existing.qty += 1;
  } else {
    bundleItems.push({ variantId, title, price, img, sellingPlans, qty: 1 });
  }
  updateCardState(variantId);
  updateFooter();
}

function removeFromBundle(variantId) {
  const item = bundleItems.find(i => i.variantId === variantId);
  if (!item) return;
  if (item.qty > 1) {
    item.qty -= 1;
  } else {
    bundleItems = bundleItems.filter(i => i.variantId !== variantId);
  }
  updateCardState(variantId);
  updateFooter();
}

// ─── CARD STATE ─────────────────────────────────────────────────────────────
function updateCardState(variantId) {
  const card = $(`.bab-card[data-variant-id="${variantId}"]`);
  if (!card) return;

  const item = bundleItems.find(i => i.variantId === variantId);
  const inBundle = !!item;

  card.classList.toggle('in-bundle', inBundle);

  const qtyVal = card.querySelector('.bab-qty-val');
  if (qtyVal) qtyVal.textContent = item ? item.qty : 0;
}

function refreshAllCards() {
  $$('.bab-card').forEach(card => {
    const variantId = card.dataset.variantId;
    updateCardState(variantId);
  });
}

// ─── FOOTER ─────────────────────────────────────────────────────────────────
function updateFooter() {
  const footer = $('.bab-sticky-footer');
  if (!footer) return;

  const totalCents = getTotalCents();
  const itemCount  = bundleItems.reduce((s, i) => s + i.qty, 0);
  const activeTier = getActiveTier(totalCents);
  const nextTier   = getNextTier(totalCents);

  // Show/hide footer
  footer.classList.toggle('hidden', itemCount === 0);

  // Item count
  const countEl = footer.querySelector('.bab-footer-count');
  if (countEl) {
    countEl.textContent = `${itemCount} item${itemCount !== 1 ? 's' : ''} in your bundle`;
  }

  // Totals
  const discountedCents = activeTier
    ? Math.round(totalCents * (1 - activeTier.pct / 100))
    : totalCents;

  const totalEl   = footer.querySelector('.bab-footer-total');
  const compareEl = footer.querySelector('.bab-footer-compare');
  const savingsEl = footer.querySelector('.bab-footer-savings');

  if (totalEl) totalEl.textContent = formatMoney(discountedCents);

  if (compareEl) {
    compareEl.textContent = activeTier ? formatMoney(totalCents) : '';
    compareEl.style.display = activeTier ? 'inline' : 'none';
  }

  if (savingsEl) {
    if (activeTier) {
      savingsEl.textContent = `${activeTier.pct}% off applied`;
      savingsEl.style.display = 'inline';
    } else {
      savingsEl.style.display = 'none';
    }
  }

  // Progress bar toward next tier (or toward min if below $30)
  const progressLabel = footer.querySelector('.bab-footer-progress-label');
  const progressBar   = footer.querySelector('.bab-footer-progress-bar');

  if (totalCents < BAB_CONFIG.MIN_ORDER_CENTS) {
    const pct = Math.round(totalCents / BAB_CONFIG.MIN_ORDER_CENTS * 100);
    if (progressBar) progressBar.style.width = pct + '%';
    if (progressLabel) {
      const remaining = formatMoney(BAB_CONFIG.MIN_ORDER_CENTS - totalCents);
      progressLabel.textContent = `Add ${remaining} to unlock checkout`;
    }
  } else if (nextTier) {
    const prevThreshold = activeTier ? activeTier.thresholdCents : BAB_CONFIG.MIN_ORDER_CENTS;
    const range  = nextTier.thresholdCents - prevThreshold;
    const filled = totalCents - prevThreshold;
    const pct    = Math.min(100, Math.round(filled / range * 100));
    if (progressBar) progressBar.style.width = pct + '%';
    if (progressLabel) {
      const remaining = formatMoney(nextTier.thresholdCents - totalCents);
      progressLabel.textContent = `Add ${remaining} more to save ${nextTier.pct}%`;
    }
  } else {
    // Max tier reached
    if (progressBar) progressBar.style.width = '100%';
    if (progressLabel) progressLabel.textContent = `Max savings unlocked: ${activeTier.pct}% off!`;
  }

  // Tier badges
  $$('.bab-tier-badge').forEach(badge => {
    const threshold = parseInt(badge.dataset.threshold, 10) * 100;
    badge.classList.toggle('active', totalCents >= threshold);
  });

  // Checkout button
  const checkoutBtn = footer.querySelector('.bab-btn-checkout');
  if (checkoutBtn) {
    const canCheckout = totalCents >= BAB_CONFIG.MIN_ORDER_CENTS;
    checkoutBtn.disabled = !canCheckout;
    checkoutBtn.title = canCheckout ? '' : `Minimum order is $${BAB_CONFIG.MIN_ORDER_CENTS / 100}`;
  }
}

// ─── MODAL ──────────────────────────────────────────────────────────────────
function openPurchaseModal() {
  const overlay = $('.bab-modal-overlay');
  if (!overlay) return;
  updateModalSummary();
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closePurchaseModal() {
  const overlay = $('.bab-modal-overlay');
  if (!overlay) return;
  overlay.classList.remove('open');
  document.body.style.overflow = '';
}

function updateModalSummary() {
  const totalCents = getTotalCents();
  const activeTier = getActiveTier(totalCents);

  const isSubscribe    = !!$('.bab-purchase-option[data-type="subscribe"].selected');
  // Subscribe gets the bundle-level discount (20%) on top if applicable, but base is the tier
  // For display: show original, discount, and final
  const tierPct        = activeTier ? activeTier.pct : 0;
  const subPct         = 20; // subscribe always gets 20% off
  // If subscribe, we apply the greater of tier OR sub discount
  const effectivePct   = isSubscribe ? Math.max(tierPct, subPct) : tierPct;
  const discountCents  = Math.round(totalCents * effectivePct / 100);
  const finalCents     = totalCents - discountCents;
  const itemCount      = bundleItems.reduce((s, i) => s + i.qty, 0);

  const rows = $('.bab-modal-summary');
  if (!rows) return;

  rows.innerHTML = `
    <div class="bab-modal-summary-row">
      <span>${itemCount} item${itemCount !== 1 ? 's' : ''}</span>
      <span>${formatMoney(totalCents)}</span>
    </div>
    ${effectivePct > 0 ? `
    <div class="bab-modal-summary-row savings">
      <span>${isSubscribe && effectivePct === subPct ? 'Subscribe & Save' : `${effectivePct}% bundle discount`}</span>
      <span>-${formatMoney(discountCents)}</span>
    </div>` : ''}
    <div class="bab-modal-summary-row">
      <span>Total</span>
      <span>${formatMoney(finalCents)}</span>
    </div>
  `;

  // Update prices on the option labels
  const subPriceEl = $('.bab-option-price[data-type="subscribe"]');
  const otpPriceEl = $('.bab-option-price[data-type="one-time"]');

  const subDiscount = Math.round(totalCents * Math.max(tierPct, subPct) / 100);
  const otpDiscount = Math.round(totalCents * tierPct / 100);

  if (subPriceEl) {
    subPriceEl.innerHTML = `<strong>${formatMoney(totalCents - subDiscount)}</strong> / order`;
  }
  if (otpPriceEl) {
    otpPriceEl.innerHTML = tierPct > 0
      ? `<strong>${formatMoney(totalCents - otpDiscount)}</strong> <s>${formatMoney(totalCents)}</s>`
      : `<strong>${formatMoney(totalCents)}</strong>`;
  }
}

function initModal() {
  // Close on overlay click
  const overlay = $('.bab-modal-overlay');
  if (overlay) {
    overlay.addEventListener('click', e => {
      if (e.target === overlay) closePurchaseModal();
    });
  }

  // Close button
  const closeBtn = $('.bab-modal-close');
  if (closeBtn) closeBtn.addEventListener('click', closePurchaseModal);

  // ESC key
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closePurchaseModal();
  });

  // Purchase type selection
  $$('.bab-purchase-option').forEach(option => {
    option.addEventListener('click', () => {
      $$('.bab-purchase-option').forEach(o => o.classList.remove('selected'));
      option.classList.add('selected');
      const radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      updateModalSummary();
    });
  });

  // Frequency selection
  $$('.bab-freq-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      $$('.bab-freq-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  // Add to cart
  const atcBtn = $('.bab-btn-atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', handleAddToCart);
  }
}

// ─── SKIO API ────────────────────────────────────────────────────────────────
async function getDynamicBox(sellingPlanId) {
  const body = {
    productVariantPlatformId: BAB_CONFIG.BUNDLE_PRODUCT_ID.toString(),
  };
  if (sellingPlanId) {
    body.sellingPlanPlatformId = sellingPlanId.toString();
  }

  const resp = await fetch('https://api.skio.com/storefront-http/get-dynamic-box-v2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-skio-storefront-token': BAB_CONFIG.SKIO_STOREFRONT_TOKEN,
    },
    body: JSON.stringify(body),
  });

  if (!resp.ok) {
    throw new Error(`Skio API error: ${resp.status}`);
  }

  const data = await resp.json();
  return data.DynamicBoxV2 || data.dynamicBox || data;
}

// ─── ADD TO CART ─────────────────────────────────────────────────────────────
async function handleAddToCart() {
  const atcBtn = $('.bab-btn-atc');
  if (!atcBtn) return;

  const purchaseType = $('input[name="bab-purchase-type"]:checked')?.value || 'one-time';
  const isSubscribe  = purchaseType === 'subscribe';

  // Get monthly selling plan ID if subscribing
  let sellingPlanId = null;
  if (isSubscribe) {
    const freqInput = $('.bab-freq-btn.selected');
    sellingPlanId = freqInput ? freqInput.dataset.sellingPlanId || null : null;

    if (!sellingPlanId || sellingPlanId === 'null') {
      showToast('No monthly subscription plan found. Please contact support.');
      return;
    }
  }

  atcBtn.classList.add('loading');
  atcBtn.disabled = true;

  try {
    // 1. Get Skio dynamic box ID
    const boxData = await getDynamicBox(isSubscribe ? sellingPlanId : null);
    const boxId   = boxData.boxId || boxData.id;

    if (!boxId) {
      throw new Error('Could not create dynamic box. Please try again.');
    }

    // 2. Build unique group index
    const uniqueId = Math.random().toString(36).slice(2, 10);

    // 3. Build cart items
    const cartItems = bundleItems.map(item => {
      // Find the correct selling plan for this specific product/frequency
      let itemSellingPlan = null;
      if (isSubscribe && item.sellingPlans && item.sellingPlans.length) {
        const freqBtn = $('.bab-freq-btn.selected');
        const freqIndex = freqBtn ? parseInt(freqBtn.dataset.freqIndex, 10) : 1;
        itemSellingPlan = item.sellingPlans[freqIndex] || item.sellingPlans[0] || null;
        if (itemSellingPlan) itemSellingPlan = parseInt(itemSellingPlan, 10);
      }

      return {
        id:       parseInt(item.variantId, 10),
        quantity: item.qty,
        selling_plan: itemSellingPlan,
        properties: {
          _dynamicBoxId:    boxId,
          _dynamicBoxIndex: uniqueId,
          _bundleQuantity:  item.qty,
        },
      };
    });

    // 4. Add to Shopify cart
    const cartResp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems }),
    });

    if (!cartResp.ok) {
      const err = await cartResp.json();
      throw new Error(err.description || 'Could not add items to cart.');
    }

    // 5. Refresh cart and open drawer
    if (typeof window.refreshCartContents === 'function') {
      await window.refreshCartContents(cartResp);
    }

    closePurchaseModal();

    if (typeof bootstrap !== 'undefined') {
      const cartOffcanvas = document.getElementById('offcanvas-cart');
      if (cartOffcanvas) {
        bootstrap.Offcanvas.getOrCreateInstance(cartOffcanvas).show();
      }
    }

    // 6. Reset bundle
    bundleItems = [];
    refreshAllCards();
    updateFooter();

  } catch (err) {
    console.error('Build a Bundle error:', err);
    showToast(err.message || 'Something went wrong. Please try again.');
  } finally {
    atcBtn.classList.remove('loading');
    atcBtn.disabled = false;
  }
}

// ─── EVENT DELEGATION: product cards ─────────────────────────────────────────
function initCardEvents() {
  document.addEventListener('click', e => {
    const addBtn = e.target.closest('[data-bab-add]');
    if (addBtn) {
      const card = addBtn.closest('.bab-card');
      if (!card || card.classList.contains('sold-out')) return;
      const { variantId, title, price, img } = card.dataset;
      const sellingPlans = card.dataset.sellingPlans
        ? card.dataset.sellingPlans.split(';').filter(Boolean)
        : [];
      addToBundle(variantId, title, parseInt(price, 10), img, sellingPlans);
      return;
    }

    const plusBtn = e.target.closest('[data-bab-plus]');
    if (plusBtn) {
      const card = plusBtn.closest('.bab-card');
      if (!card) return;
      const { variantId, title, price, img } = card.dataset;
      const sellingPlans = card.dataset.sellingPlans
        ? card.dataset.sellingPlans.split(';').filter(Boolean)
        : [];
      addToBundle(variantId, title, parseInt(price, 10), img, sellingPlans);
      return;
    }

    const minusBtn = e.target.closest('[data-bab-minus]');
    if (minusBtn) {
      const card = minusBtn.closest('.bab-card');
      if (!card) return;
      removeFromBundle(card.dataset.variantId);
      return;
    }
  });
}

// ─── FOOTER CHECKOUT BUTTON ──────────────────────────────────────────────────
function initCheckoutButton() {
  const btn = $('.bab-btn-checkout');
  if (btn) {
    btn.addEventListener('click', () => {
      if (bundleItems.length === 0) return;
      openPurchaseModal();
    });
  }
}

// ─── INIT ────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  initTabs();
  initCardEvents();
  initCheckoutButton();
  initModal();
  updateFooter();
});
